module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-22.eaecc865.jpg";